/* eslint-disable react-hooks/exhaustive-deps */
import { ApiKeyFetch } from 'api/fetchers/apiKey';
import { emailRegex } from 'components/InputsMex/validaciones';
import ProgressSpinner from 'components/PogressSpinners/ProgressSpinner';
import { ambienteAplicacion } from 'constants/urls';
import { URLS_PHP_7 } from 'constants/urls_v2';
import useCustomToast from 'hooks/useCustomToasts';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import ResumenDatosPlan from '../componentes/ResumenDatosPlanMarineInland';
import ResumenDatosSeguro from '../componentes/ResumenDatosSeguroMarineInland';
import { MarineInland } from '../constantes/general';

const API = ApiKeyFetch.instance();

const ResumenInland = ({
  prod,
  imgBreadCrum,
  datosTarifacion,
  idCotizacion,
  cotizacion,
  recalculando,
  tarifar,
  bloquearEmision = false,
}) => {
  const [enviandoCorreo, enviarCorreo] = useState(false);

  const { register, errors, handleSubmit, reset } = useForm({
    mode: 'onChange',
    shouldUnregister: true,
  });

  const { addSuccessToast, addWarningToast } = useCustomToast();

  useEffect(() => {
    reset({ correo: cotizacion.carContratante.usuCorreo });
  }, [cotizacion.carContratante.usuCorreo, reset]);

  const onEnviarCorreo = async (data) => {
    enviarCorreo(true);
    const Data = {
      ambiente: ambienteAplicacion,
      prodCodigo: MarineInland.codProducto,
      pasoCodigo: 'enviarCorreoCotizacion',
      items: {
        cotCodigo: idCotizacion,
        correo: data.correo,
      },
    };
    const res = await API.post(URLS_PHP_7.cotizacion.actualizarCotizacion, Data);

    if (res.transaccion) {
      addSuccessToast(`Hemos enviado tu cotización al correo ${data.correo}`);

      reset();
    } else {
      addWarningToast('Ha ocurrido un problema al enviar el correo');
      reset({ correo: data.correo });
    }
    enviarCorreo(false);
  };

  return (
    <div className="row justify-content-around">
      <ResumenDatosPlan
        tarifar={tarifar}
        datosTarifacion={datosTarifacion}
        prod={prod}
        cotizacion={cotizacion}
        imgBreadCrum={imgBreadCrum}
        recalculando={recalculando}
      />

      <div className="col-10 col-md-5 border-mex-ap">
        <div className="row justify-content-center h-100">
          <div className="col-11 mt-5 mx-auto align-self-center">
            {recalculando && <ProgressSpinner label="Recalculando información..." />}

            {!recalculando && <ResumenDatosSeguro datosTarifacion={datosTarifacion} />}

            <div className="row justify-content-between mt-3">
              <div className="col-12 text-right">
                <a href={cotizacion.carUrlPdf} target="_blank" rel="noopener noreferrer">
                  <button
                    className="btn btn-primary  text-uppercase"
                    type="button"
                    disabled={recalculando || bloquearEmision}
                  >
                    Descargar Cotización
                  </button>
                </a>
              </div>

              <div className="col-12 my-3">
                {!enviandoCorreo && (
                  <React.Fragment>
                    <label className="lbl-env-correo font-20px" htmlFor="env-correo-api">
                      Confirma tu correo para recibir tu cotización ahora
                    </label>
                    <div className="input-group input-group-lg">
                      <input
                        type="text"
                        className="form-control enviar-cot"
                        aria-label="Sizing example input"
                        aria-describedby="inputGroup-sizing-lg"
                        placeholder="Ingresa tu correo "
                        id="env-correo-api"
                        name="correo"
                        ref={register({
                          required: 'Este campo es obligatorio',
                          pattern: {
                            value: emailRegex,
                            message: 'Ingrese un correo válido',
                          },
                        })}
                      />

                      <div className="input-group-prepend">
                        <button
                          className="btn btn-primary rounded-right text-uppercase"
                          onClick={handleSubmit(onEnviarCorreo)}
                          disabled={recalculando || bloquearEmision}
                        >
                          Enviar cotización
                        </button>
                      </div>
                    </div>

                    <strong className="error-msg-input">{errors?.correo?.message}</strong>
                  </React.Fragment>
                )}
                {enviandoCorreo && (
                  <React.Fragment>
                    <h3 className="font-mex">Enviando correo...</h3>
                  </React.Fragment>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResumenInland;
